import { ExternalIntegrationCard } from '../ExternalIntegrationCard/ExternalIntegrationCard'
import { ExternalIntegrationEnum, GoHighLevelIntegration } from 'api/clients/ExternalIntegrationsClient'
import { GoHighLevel } from 'blaze-ui/icons/20'
import { Settings } from 'blaze-ui/icons/20'
import { CardButtons } from './CardButtons'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { Button } from 'blaze-ui/Button'
import { GoHighLevelConfigurationModal } from 'components/GoHighLevelConfigurationModal/GoHighLevelConfigurationModal'
import { useModals } from 'almanac-ui/Modal'
import { useBlogIntegrations } from 'hooks/useBlogIntegrations'
import Styles from './GoHighLevelCard.module.scss'

export const GoHighLevelCard = ({
  integrations = [],
  canConnect,
  isDisconnected = false,
}: {
  integrations?: GoHighLevelIntegration[]
  canConnect?: boolean
  isDisconnected?: boolean
}) => {
  const { initiateOauth } = useInitiateOauth()
  const goHighLevelEnabled = useFlipperFlag('go_high_level_integration')
  const { openModal } = useModals()
  const { getRestrictionMessage } = useBlogIntegrations()

  const isConnected = integrations.length > 0
  const showGearIcon = goHighLevelEnabled && isConnected && !isDisconnected

  const restrictionMessage = getRestrictionMessage(ExternalIntegrationEnum.GoHighLevel)
  const canConnectGoHighLevel = canConnect ?? !restrictionMessage

  const handleConnect = () => {
    initiateOauth(ExternalIntegrationEnum.GoHighLevel)
  }

  const handleConfigureClick = () => {
    if (integrations[0]) {
      openModal(GoHighLevelConfigurationModal, { integration: integrations[0] })
    }
  }

  const cardContent = (
    <div className={Styles.cardWrapper}>
      <ExternalIntegrationCard
        title={'GoHighLevel'}
        description={'Connect your GoHighLevel account to manage blogs, contacts, and user data'}
        integrations={integrations}
        icon={<GoHighLevel size={20} />}
        isDisabled={!canConnectGoHighLevel}
        isDisconnected={isDisconnected}
        buttons={
          <CardButtons
            onConnect={handleConnect}
            provider={ExternalIntegrationEnum.GoHighLevel}
            isConnected={integrations.length > 0}
            integration={integrations[0]}
            isDisabled={!canConnectGoHighLevel}
            tooltipMessage={restrictionMessage || undefined}
            isDisconnected={isDisconnected}
          />
        }
      />
      {showGearIcon && (
        <div className={Styles.gearButtonWrapper}>
          <Button
            variant="tertiary"
            size="xs"
            onPress={handleConfigureClick}
            aria-label={`Configure GoHighLevel integration`}
            frontIcon={Settings}
          />
        </div>
      )}
    </div>
  )

  return cardContent
}
